"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminOrderErrorAlert = AdminOrderErrorAlert;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
function AdminOrderErrorAlert({ code }) {
    const intl = (0, react_intl_1.useIntl)();
    let message = intl.formatMessage({ id: 'general.error' });
    let description = intl.formatMessage({ id: 'general.something_went_wrong' });
    if (code === types_1.EProductValidationErrorCode.INVALID_PRODUCT) {
        message = intl.formatMessage({ id: 'admin.order.error.product.message' });
        description = intl.formatMessage({ id: 'admin.order.error.product.description' });
    }
    if (code === types_1.EProductValidationErrorCode.INVALID_AMOUNT) {
        message = intl.formatMessage({ id: 'admin.order.error.amount.message' });
        description = intl.formatMessage({ id: 'admin.order.error.amount.description' });
    }
    if (code === types_1.EProductValidationErrorCode.INVALID_COUPON) {
        message = intl.formatMessage({ id: 'admin.order.error.coupon.message' });
        description = intl.formatMessage({ id: 'admin.order.error.coupon.description' });
    }
    if (code === types_1.EProductValidationErrorCode.ALREADY_ACTIVE_PREMIUM_SUBSCRIPTION) {
        message = intl.formatMessage({ id: 'admin.order.error.has_active_subscription.message' });
        description = intl.formatMessage({ id: 'admin.order.error.has_active_subscription.description' });
    }
    return (0, jsx_runtime_1.jsx)(elements_1.Alert, { className: "m-b-m", type: "error", message: message, description: description });
}
